import React from 'react'
import { AppRetailerBlockContainer } from "@components/DataBlocks"
import { Box } from "@mui/material"


export default function sitesColumn() {

	return [{
		name: "sitesNameRaw",
		label: "Sites",
		options: {
			display: 'excluded',
			customBodyRowRenderLite: (value) => {
				return value.length > 0 ? value.join(', ') : 'Any'
			},
			filterOptions: {
				logic: (nameRawArray, filterVal) => {
					if (!filterVal || !filterVal.length) return false
					return !nameRawArray.includes(filterVal[0])
				}
			}
		}
	}, {
		name: 'sitesName',
		label: 'Sites',
		options: {
			filter: false,
			customBodyRowRenderLite: value => <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
				<AppRetailerBlockContainer rows={value}/>
			</Box>,
		}
	}]
}